"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var Dialog = _interopRequireWildcard(require("@radix-ui/react-dialog"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _framerMotion = require("framer-motion");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBModal = require("../HBModal/HBModal.styles");
var _shared = require("../../utils/shared.utils");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _ModalInternalContext = require("./ModalInternalContext");
var _HBModalProvider = require("../HBModalProvider/HBModalProvider");
var _variables = require("../../styles/variables");
var _excluded = ["children", "testIdName", "isOpen", "onClose"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBModalBase = function HBModalBase(_ref, ref) {
  var _modals$, _props$testId;
  var children = _ref.children,
    testIdName = _ref.testIdName,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _containerRef = (0, _react.useRef)(null);
  var containerRef = ref !== null && ref !== void 0 ? ref : _containerRef;
  var _useRef = (0, _react.useRef)((0, _shared.guid)()),
    internalStableId = _useRef.current;
  var id = props.id || internalStableId;
  var idRef = (0, _react.useRef)(id);
  idRef.current = id;
  var isOpenRef = (0, _react.useRef)(isOpen);
  isOpenRef.current = isOpen;
  var onCloseRef = (0, _react.useRef)(onClose);
  onCloseRef.current = onClose;
  var _useHBModalContext = (0, _HBModalProvider.useHBModalContext)(),
    _useHBModalContext2 = (0, _slicedToArray2["default"])(_useHBModalContext, 2),
    modals = _useHBModalContext2[0],
    setModals = _useHBModalContext2[1];
  (0, _react.useEffect)(function () {
    function removeModal() {
      setModals(function (prevModals) {
        return prevModals.filter(function (modal) {
          return modal.idRef.current !== id;
        });
      });
    }
    if (isOpen) {
      setModals(function (prevModals) {
        return [].concat((0, _toConsumableArray2["default"])(prevModals), [{
          idRef: idRef,
          containerRef: containerRef,
          onCloseRef: onCloseRef
        }]);
      });
      return removeModal;
    } else {
      removeModal();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);
  var isBottomModal = ((_modals$ = modals[0]) === null || _modals$ === void 0 ? void 0 : _modals$.idRef.current) === id;
  var portalTarget = function (_modals$parentIndex, _modals) {
    if (isBottomModal) {
      return document.body;
    }
    var index = modals.findIndex(function (modal) {
      return modal.idRef.current === id;
    });
    var parentIndex = index - 1;
    var parentModal = (_modals$parentIndex = modals[parentIndex]) === null || _modals$parentIndex === void 0 ? void 0 : _modals$parentIndex.containerRef.current;
    var lastModal = (_modals = modals[modals.length - 1]) === null || _modals === void 0 ? void 0 : _modals.containerRef.current;
    return parentModal || lastModal || document.body;
  }();
  var testId = (_props$testId = props.testId) !== null && _props$testId !== void 0 ? _props$testId : props.id;
  var containerTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'container',
    componentName: 'HBModal'
  });
  return /*#__PURE__*/_react["default"].createElement(_ModalInternalContext.ModalInternalProvider, {
    value: {
      testIdName: testIdName,
      testId: testId
    }
  }, /*#__PURE__*/_react["default"].createElement(Dialog.Root, {
    open: isOpen,
    onOpenChange: function onOpenChange(newIsOpen) {
      if (!newIsOpen) {
        onClose();
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(Dialog.Portal, {
    forceMount: true,
    container: portalTarget
  }, /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, null, isOpen && /*#__PURE__*/_react["default"].createElement(Overlay, (0, _extends2["default"])({}, _HBModal.MODAL_ANIMATION, {
    $isBottomModal: isBottomModal
  }), /*#__PURE__*/_react["default"].createElement(Container, {
    id: props.id,
    "data-testid": containerTestId,
    ref: containerRef,
    $isBottomModal: isBottomModal
  }, children))))));
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(HBModalBase); // -------------------------- Styles -------------------------- //
var borderRadius = (0, _styledComponents.css)(["border-radius:6px;"]);
var Overlay = (0, _styledComponents["default"])((0, _framerMotion.motion)(Dialog.Overlay)).withConfig({
  displayName: "HBModalBase__Overlay",
  componentId: "sc-1y5775g-0"
})(["inset:0;display:grid;place-content:center;z-index:", ";", ""], _variables.Z_INDEX.POPOVER, function (_ref2) {
  var $isBottomModal = _ref2.$isBottomModal;
  return $isBottomModal ? (0, _styledComponents.css)(["padding:16px;position:fixed;background-color:", ";"], _colors["default"].black_07) : (0, _styledComponents.css)(["position:absolute;background-color:", ";", ""], _colors["default"].white_085, borderRadius);
});
var Container = (0, _styledComponents["default"])(Dialog.Content).withConfig({
  displayName: "HBModalBase__Container",
  componentId: "sc-1y5775g-1"
})(["position:relative;background-color:", ";outline:none;&,> *:only-child{", "}", ""], _colors["default"].white, borderRadius, function (_ref3) {
  var $isBottomModal = _ref3.$isBottomModal;
  return !$isBottomModal && (0, _styledComponents.css)(["box-shadow:0px 20px 40px ", ";"], _colors["default"].black_02);
});
//# sourceMappingURL=HBModalBase.js.map